<dx-popup
  [visible]="visible"
  [showTitle]="true"
  title="Resolve Duplicate Products"
  [width]="800"
  [height]="600"
  [showCloseButton]="false"
  [hideOnOutsideClick]="false">
  
  <div *dxTemplate="let data of 'content'">
    <div class="duplicate-resolution-content">
      <p><strong>The following products exist in multiple promotion groups. Please select which groups to remove them from:</strong></p>
      
      @for (duplicate of duplicates; track duplicate.product_id) {
        <div class="duplicate-item">
          <h4>{{ duplicate.product_name }} ({{ duplicate.product_code }})</h4>
          <p>Found in {{ duplicate.promotion_group_names.length }} groups:</p>
          
          @for (group of duplicate.promotion_groups; track group.id; let i = $index) {
            <div class="group-checkbox">
              <dx-check-box
                [text]="group.name"
                [value]="isGroupSelectedForRemoval(duplicate.product_id, group.id)"
                (onValueChanged)="onGroupSelectionChanged($event, duplicate.product_id, group.id)">
              </dx-check-box>
              <span class="checkbox-label">Remove from this group</span>
            </div>
          }
          
          @if (duplicates.indexOf(duplicate) < duplicates.length - 1) {
            <hr>
          }
        </div>
      }
      
      <!-- Buttons at the bottom of content -->
      <div class="popup-buttons" style="margin-top: 20px; text-align: right; border-top: 1px solid #ddd; padding-top: 15px;">
        <dx-button
          text="Cancel"
          type="normal"
          stylingMode="outlined"
          style="margin-right: 10px;"
          (onClick)="onCancel()">
        </dx-button>
        <dx-button
          text="Apply Changes"
          type="success"
          [disabled]="!hasValidSelections()"
          (onClick)="onApply()">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>